let googleMapsLoaded = false;
let googleMapsLoadPromise = null;

export const loadGoogleMaps = (apiKey) => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return Promise.reject(new Error("Google Maps can only be loaded in a browser."));
  }

  if (window.google?.maps?.places) {
    googleMapsLoaded = true;
    return Promise.resolve(window.google.maps);
  }

  if (window.google?.maps?.importLibrary) {
    return window.google.maps.importLibrary("places").then(() => {
      googleMapsLoaded = true;
      return window.google.maps;
    });
  }

  if (googleMapsLoadPromise) {
    return googleMapsLoadPromise;
  }

  googleMapsLoadPromise = new Promise((resolve, reject) => {
    // Script already injected but still loading?
    const existingScript = document.getElementById("google-maps-script");
    if (existingScript && !googleMapsLoaded) {
      existingScript.addEventListener("load", () => {
        googleMapsLoaded = true;
        resolve(window.google?.maps);
      });
      existingScript.addEventListener("error", () => {
        reject(new Error("Google Maps script failed to load."));
      });
      return;
    }

    // Inject script first time
    const script = document.createElement("script");
    script.id = "google-maps-script";
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}&libraries=places`;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      googleMapsLoaded = true;
      resolve(window.google?.maps);
    };
    script.onerror = () => {
      googleMapsLoadPromise = null;
      reject(new Error("Google Maps script failed to load."));
    };
    document.head.appendChild(script);
  });

  return googleMapsLoadPromise;
};
